import script from "./SearchForecastForReceipt.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchForecastForReceipt.vue?vue&type=script&lang=ts&setup=true"

import "./SearchForecastForReceipt.vue?vue&type=style&index=0&id=f96c3df2&lang=scss&scoped=true"
import "./SearchForecastForReceipt.vue?vue&type=style&index=1&id=f96c3df2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f96c3df2"]])

export default __exports__